import { createDebugger } from '@iotize/common/debug';
const prefix = '@iotize/common:task-manager';
export const debug = createDebugger(prefix);
